import { Routes } from '@angular/router';
import { NotfoundpageComponent } from './notfoundpage.component';


export const appRoutes: Routes = [
  {
    path: '', component: NotfoundpageComponent,
    },
];

